// import React from "react";
// import { Box, Container, Typography, IconButton } from "@mui/material";
// import { Facebook, Instagram, Twitter } from "@mui/icons-material";

// const Footer = () => {
//   return (
//     <Box
//       component="footer"
//       sx={{
//         background: "linear-gradient(135deg, #3f51b5, #1a237e)",
//         color: "white",
//         py: 4,
//         mt: "auto", // This helps push footer to bottom if using flex layout
//         width: { sm: "calc(100% - 240px)" }, // Adjust width accounting for sidebar
//         marginLeft: { sm: "240px" }, // Shift right by sidebar width
//         position: "relative",
//         zIndex: 1000, // Ensure footer stays above other content
//       }}
//     >
//       <Container maxWidth="lg" sx={{ pl: { sm: "20px" } }}>
//         <Box
//           display="flex"
//           alignItems="center"
//           justifyContent="space-between"
//           flexDirection={{ xs: "column", md: "row" }}
//           gap={2}
//         >
//           <Typography variant="body2" color="inherit">
//             © {new Date().getFullYear()} InfyU Labs, All rights reserved.
//           </Typography>

//           <Box>
//             <IconButton
//               href="#"
//               color="inherit"
//               sx={{
//                 transition: "transform 0.3s ease, color 0.3s ease",
//                 "&:hover": { transform: "scale(1.2)", color: "#ffeb3b" },
//               }}
//             >
//               <Facebook />
//             </IconButton>
//             <IconButton
//               href="#"
//               color="inherit"
//               sx={{
//                 transition: "transform 0.3s ease, color 0.3s ease",
//                 "&:hover": { transform: "scale(1.2)", color: "#ffeb3b" },
//               }}
//             >
//               <Instagram />
//             </IconButton>
//             <IconButton
//               href="#"
//               color="inherit"
//               sx={{
//                 transition: "transform 0.3s ease, color 0.3s ease",
//                 "&:hover": { transform: "scale(1.2)", color: "#ffeb3b" },
//               }}
//             >
//               <Twitter />
//             </IconButton>
//           </Box>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Footer;


import React from "react";
import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Instagram,
  LinkedIn,
  Pinterest,
  Twitter,
} from "@mui/icons-material";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const socialLinks = [
    { icon: <Instagram sx={{ fontSize: 16 }} />, href: "#" },
    {
      icon: <LinkedIn sx={{ fontSize: 16 }} />,
      href: "https://www.linkedin.com/company/infyu-labs/?originalSubdomain=in",
    },
    { icon: <Pinterest sx={{ fontSize: 16 }} />, href: "#" },
    { icon: <Twitter sx={{ fontSize: 16 }} />, href: "#" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "transparent",
        mt: "auto",
        width: "100%",
        position: "relative",
        px: isMobile ? 2 : 4,
        py: isMobile ? 1.5 : 0,
        minHeight: isMobile ? "auto" : "60px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          gap: isMobile ? 1.5 : 0,
        }}
      >
        {/* Left: Copyright */}
        <Typography
          variant="body2"
          sx={{
            color: "rgba(255,255,255,0.5)",
            fontSize: "0.8rem",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          &copy; {new Date().getFullYear()} InfyU Labs. All rights reserved.
        </Typography>

        {/* Center: Social Icons */}
        <Box display="flex" gap={1} alignItems="center">
          {socialLinks.map((item, idx) => (
            <IconButton
              key={idx}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "rgba(255,255,255,0.1)",
                color: "#FFFFFF",
                width: 30,
                height: 30,
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.2)",
                  boxShadow: "0 0 8px rgba(255,255,255,0.15)",
                },
                transition: "all 0.2s ease",
              }}
            >
              {item.icon}
            </IconButton>
          ))}
        </Box>

        {/* Right: Contact Info */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: isMobile ? 0.5 : 2,
          }}
        >
          <Typography
            component="a"
            href="mailto:hello@infyulabs.com"
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontSize: "0.8rem",
              textDecoration: "none",
              "&:hover": { color: "rgba(255,255,255,0.9)" },
              transition: "color 0.2s ease",
            }}
          >
            hello@infyulabs.com
          </Typography>
          <Typography
            component="a"
            href="https://infyulabs.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontSize: "0.8rem",
              textDecoration: "none",
              "&:hover": { color: "rgba(255,255,255,0.9)" },
              transition: "color 0.2s ease",
            }}
          >
            infyulabs.com
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
